import { AuctionBidHistoryDTO } from "./auctionBidHistoryDTO";

export class PropertyBidHistoryDTO{
    public propertyId!:number;
    public auctionBidHistories!:AuctionBidHistoryDTO[];
}